import { getTenantConfig } from './config';
import customClientConfig from './customClientConfig';

const { tenant } = getTenantConfig();

// Tenants using contact-specific invite codes declare the code shape via
// `additionalInviteCodeFormat` in customClientConfig (e.g. Axsome's
// `<meetingId>:<contactId>`). The first capture group must be the meeting id.
//
// The code has to be parsed before the meeting is fetched — that's how we find
// the meeting — so the shape comes from tenant config. Whether the
// contact-specific *flow* actually runs is a separate, per-meeting decision made
// from the meeting type's Registration_IsContactSpecific flag, surfaced as
// `meetingInfo.is_contact_specific`. A tenant can therefore have the format
// configured while individual meetings still use the standard flow.
const additionalFormatPattern = customClientConfig[tenant]?.additionalInviteCodeFormat;

// True when this tenant issues contact-specific codes at all. Whether any given
// meeting actually uses that flow is still decided per meeting by
// `meetingInfo.is_contact_specific`.
export const tenantUsesContactSpecificCodes = Boolean(additionalFormatPattern);

const matchCode = (code) => {
  if (!code || !additionalFormatPattern) return null;
  return code.trim().match(new RegExp(additionalFormatPattern));
};

export const isContactSpecificCode = (code) => Boolean(matchCode(code));

// Returns the meetingId portion of a contact-specific code, or null when the
// code isn't in this tenant's configured format.
export const getMeetingIdFromCode = (code) => {
  const match = matchCode(code);
  return match ? match[1] : null;
};
